<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" {...$$props}>
  <path
    d="M19 6.50044L17.7143 5L12.0418 10.5358L6.45311 5L5 6.57337L10.5188 12.0508L5.06961 17.4266L6.52269 19L12.0418 13.5514L17.5469 19L19 17.4266L13.5647 12.0508L19 6.50044Z"
    fill="currentColor"
    fill-rule="evenodd"
  />
</svg>
